<template>
  <div class="tw:flex tw:flex-row tw:gap-2 tw:p-3 tw:border-b tw:border-default-200">
    <EdroneTag
      v-for="group in groups"
      :key="group.group"
      :unique-id="`search-bar-group-by-tag-${group.group}`"
      :text="group.label"
      type="default"
      :active="selectedGroup === group.group"
      :show-close-icon="false"
      @click="$emit('groupBy', group.group)"
    >
      <template v-if="!hideCounter" #suffix>
        <EdroneBadge :label="getCount(group.count)" class="tw:ml-1" size="small" />
      </template>
    </EdroneTag>
  </div>
</template>

<script setup lang="ts">
import EdroneBadge from "edrone-components/EdroneBadge/EdroneBadge.vue";
import EdroneTag from "edrone-components/EdroneTag.vue";
import { SEARCH_BAR_GROUP } from "vue-app/components/SearchBar/SearchBar.constants";
import { formatNumberV2 } from "vue-app/utils/functions";

interface Props {
  selectedGroup: SEARCH_BAR_GROUP;
  groups: { label: string; group: SEARCH_BAR_GROUP; count: number; disabled: boolean }[];
  hideCounter?: boolean;
}

interface Emits {
  groupBy: [group: SEARCH_BAR_GROUP];
}

defineProps<Props>();
defineEmits<Emits>();

const getCount = (count: number) => {
  if (count === 10000) {
    return `${formatNumberV2(count)} +`;
  }

  return formatNumberV2(count);
};
</script>
